import { priceFormatter } from '@2wunder/klarx-tool'
import { Space } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React from 'react'

const PriceInfoItem: React.FC<MemberProps<Pick<ILineItem, 'name' | 'discountedUnitPrice'>>> = ({
  member
}) => {
  const { tRecordType } = ToolBox.useString()

  return (
    <Space className="justify-content-between full-width">
      <span>{member.name}</span>
      <span>
        {member.discountedUnitPrice > 0
          ? priceFormatter(member.discountedUnitPrice)
          : tRecordType(RecordType.subItem, 'inclusive')}
      </span>
    </Space>
  )
}

export default PriceInfoItem
